import Api from '../connection';

const title = `extract`;

export default {
	findAll(object, currentPage, perPage, filters, OrderBy) {
		return Api.applikasi.get(
			`${title}?param0=${object}&param1=${currentPage}&param2=${perPage}&param3=${filters}&param4=${OrderBy}`,
		);
	},
	create(object, data) {
		return Api.applikasi.post(`${title}/${object}`, data);
	},
	update(object, data) {
		return Api.applikasi.put(`${title}/${object}`, data);
	},
	findId(id, param0) {
		return Api.applikasi.get(`${title}/${id}?param0=${param0}`);
	},
    deleteList(id, data) {
        return Api.applikasi.delete(`${title}/${id}`, data);
    },
};
